import { useState } from "react";

// ── Descargas Operadores con acordeón Mes → Día ──────────────────
export const GrupoDia = ({ dia, registros, onEliminar }) => {
  const [abierto, setAbierto] = useState(false);
  return (
    <div className="border border-gray-100 rounded-xl overflow-hidden">
      <button
        onClick={() => setAbierto(a => !a)}
        className="w-full flex items-center justify-between px-4 py-2.5 bg-gray-50 hover:bg-gray-100 transition-all"
      >
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-gray-600 capitalize">{dia}</span>
          <span className="text-xs text-gray-400 bg-white border border-gray-200 px-2 py-0.5 rounded-full">{registros.length}</span>
        </div>
        <span className="text-gray-400 text-xs">{abierto ? "▲" : "▼"}</span>
      </button>
      {abierto && (
        <div className="divide-y bg-white">
          {registros.map(l => (
            <div key={l.id} className="p-4 space-y-1">
              <div className="flex items-center justify-between">
                <p className="font-semibold text-gray-800 text-sm">🚛 {l.empresa}</p>
                <span className="text-xs text-gray-400">
                  {new Date(l.hora_llegada).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}
                </span>
              </div>
              <p className="text-xs text-gray-600">👤 {l.nombre_conductor}</p>
              <p className="text-xs text-gray-600">🚗 {l.matricula}</p>
              <div className="flex justify-end pt-1">
                <button
                  onClick={() => onEliminar(l.id)}
                  className="text-xs bg-red-50 text-red-600 px-2 py-1 rounded-lg border border-red-200 hover:bg-red-100"
                >
                  🗑️ Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
